import React, { useState } from "react";
import "./Students.css";
import AdminLayout from "../../../layouts/AdminLayout/AdminLayout";

const StudentsManagement = () => {
  const [selectedFilter, setSelectedFilter] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [viewMode, setViewMode] = useState("table");

  const [students, setStudents] = useState([
    {
      id: 1,
      name: "Ahmed Khan",
      email: "ahmed.khan@email.com",
      role: "Student",
      status: "Active",
      joinedDate: "2024-01-15",
      coursesEnrolled: 5,
      coursesCompleted: 2,
      avatar: "AK",
      phone: "+92 300 1234567",
      location: "Karachi, Pakistan",
    },
    {
      id: 3,
      name: "Hassan Raza",
      email: "hassan.raza@email.com",
      role: "Student",
      status: "Inactive",
      joinedDate: "2024-03-10",
      coursesEnrolled: 3,
      coursesCompleted: 1,
      avatar: "HR",
      phone: "+92 333 5551234",
      location: "Islamabad, Pakistan",
    },
    {
      id: 4,
      name: "Fatima Malik",
      email: "fatima.malik@email.com",
      role: "Student",
      status: "Active",
      joinedDate: "2024-04-05",
      coursesEnrolled: 8,
      coursesCompleted: 5,
      avatar: "FM",
      phone: "+92 345 7778888",
      location: "Multan, Pakistan",
    },
  ]);

  const stats = {
    total: students.length,
    active: students.filter((s) => s.status === "Active").length,
    inactive: students.filter((s) => s.status === "Inactive").length,
    avgCompletion: students.length
      ? Math.round(
          (students.reduce(
            (acc, s) =>
              acc +
              (s.coursesEnrolled > 0
                ? s.coursesCompleted / s.coursesEnrolled
                : 0),
            0,
          ) /
            students.length) *
            100,
        )
      : 0,
  };

  const filteredStudents = students.filter((student) => {
    const matchesFilter =
      selectedFilter === "all" ||
      student.status.toLowerCase() === selectedFilter;
    const matchesSearch =
      student.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      student.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
      String(student.id).includes(searchQuery);
    return matchesFilter && matchesSearch;
  });

  const handleStudentClick = (student) => setSelectedStudent(student);
  const closeModal = () => setSelectedStudent(null);

  const handleToggleStatus = (e, studentId) => {
    e.stopPropagation();
    setStudents(
      students.map((s) =>
        s.id === studentId
          ? { ...s, status: s.status === "Active" ? "Inactive" : "Active" }
          : s,
      ),
    );
  };

  const exportToCSV = () => {
    const headers = [
      "ID",
      "Name",
      "Email",
      "Status",
      "Enrolled",
      "Completed",
      "Joined Date",
    ];
    const csvData = filteredStudents.map((s) => [
      s.id,
      s.name,
      s.email,
      s.status,
      s.coursesEnrolled,
      s.coursesCompleted,
      s.joinedDate,
    ]);
    const csvContent = [
      headers.join(","),
      ...csvData.map((row) => row.map((cell) => `"${cell}"`).join(",")),
    ].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.setAttribute("href", URL.createObjectURL(blob));
    link.setAttribute("download", `students_export_${Date.now()}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <AdminLayout>
      <div className="stud-container">
        <div className="stud-header">
          <p className="stud-subtitle">
            Manage all enrolled students and their progress
          </p>
          <button className="stud-export-btn" onClick={exportToCSV}>
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              <polyline points="7 10 12 15 17 10"></polyline>
              <line x1="12" y1="15" x2="12" y2="3"></line>
            </svg>
            Export CSV
          </button>
        </div>

        <div className="stud-stats-grid">
          <div className="stud-stat-card">
            <div className="stud-stat-icon stud-icon-total">
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
            </div>
            <div className="stud-stat-info">
              <span className="stud-stat-num">{stats.total}</span>
              <span className="stud-stat-lbl">Total Students</span>
            </div>
          </div>

          <div className="stud-stat-card">
            <div className="stud-stat-icon stud-icon-active">
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
              </svg>
            </div>
            <div className="stud-stat-info">
              <span className="stud-stat-num">{stats.active}</span>
              <span className="stud-stat-lbl">Active</span>
            </div>
          </div>

          <div className="stud-stat-card">
            <div className="stud-stat-icon stud-icon-inactive">
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="8" y1="12" x2="16" y2="12"></line>
              </svg>
            </div>
            <div className="stud-stat-info">
              <span className="stud-stat-num">{stats.inactive}</span>
              <span className="stud-stat-lbl">Inactive</span>
            </div>
          </div>

          <div className="stud-stat-card">
            <div className="stud-stat-icon stud-icon-completion">
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
              </svg>
            </div>
            <div className="stud-stat-info">
              <span className="stud-stat-num">{stats.avgCompletion}%</span>
              <span className="stud-stat-lbl">Avg Completion</span>
            </div>
          </div>
        </div>

        <div className="stud-controls">
          <div className="stud-filter-tabs">
            {["all", "active", "inactive"].map((f) => (
              <button
                key={f}
                className={`stud-filter-tab ${selectedFilter === f ? "stud-active" : ""}`}
                onClick={() => setSelectedFilter(f)}
              >
                {f === "all"
                  ? "All Students"
                  : f.charAt(0).toUpperCase() + f.slice(1)}
              </button>
            ))}
          </div>

          <div className="stud-control-right">
            <div className="stud-search-box">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <circle cx="11" cy="11" r="8"></circle>
                <path d="m21 21-4.35-4.35"></path>
              </svg>
              <input
                type="text"
                placeholder="Search by name, email, or ID..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
            <div className="stud-view-toggle">
              <button
                className={`stud-view-btn ${viewMode === "table" ? "stud-active" : ""}`}
                onClick={() => setViewMode("table")}
                title="Table View"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <line x1="8" y1="6" x2="21" y2="6"></line>
                  <line x1="8" y1="12" x2="21" y2="12"></line>
                  <line x1="8" y1="18" x2="21" y2="18"></line>
                  <line x1="3" y1="6" x2="3.01" y2="6"></line>
                  <line x1="3" y1="12" x2="3.01" y2="12"></line>
                  <line x1="3" y1="18" x2="3.01" y2="18"></line>
                </svg>
              </button>
              <button
                className={`stud-view-btn ${viewMode === "grid" ? "stud-active" : ""}`}
                onClick={() => setViewMode("grid")}
                title="Grid View"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <rect x="3" y="3" width="7" height="7"></rect>
                  <rect x="14" y="3" width="7" height="7"></rect>
                  <rect x="14" y="14" width="7" height="7"></rect>
                  <rect x="3" y="14" width="7" height="7"></rect>
                </svg>
              </button>
            </div>
          </div>
        </div>

        {viewMode === "table" && (
          <div className="stud-table-wrapper">
            <table className="stud-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Student</th>
                  <th>Status</th>
                  <th>Courses (Done/Enrolled)</th>
                  <th>Progress</th>
                  <th>Joined</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredStudents.map((student) => {
                  const progress =
                    student.coursesEnrolled > 0
                      ? Math.round(
                          (student.coursesCompleted / student.coursesEnrolled) *
                            100,
                        )
                      : 0;
                  return (
                    <tr
                      key={student.id}
                      onClick={() => handleStudentClick(student)}
                    >
                      <td>
                        <span className="stud-id-badge">{student.id}</span>
                      </td>
                      <td>
                        <div className="stud-cell">
                          <div className="stud-avatar">{student.avatar}</div>
                          <div className="stud-info">
                            <span className="stud-name">{student.name}</span>
                            <span className="stud-email">{student.email}</span>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span
                          className={`stud-status-badge stud-status-${student.status.toLowerCase()}`}
                        >
                          {student.status}
                        </span>
                      </td>
                      <td>
                        <span className="stud-course-count">
                          {student.coursesCompleted}/{student.coursesEnrolled}
                        </span>
                      </td>
                      <td>
                        <div className="stud-progress-wrap">
                          <div className="stud-progress-bar">
                            <div
                              className="stud-progress-fill"
                              style={{ width: `${progress}%` }}
                            ></div>
                          </div>
                          <span className="stud-progress-pct">{progress}%</span>
                        </div>
                      </td>
                      <td className="stud-joined-date">{student.joinedDate}</td>
                      <td>
                        <div className="stud-action-btns">
                          <button
                            className="stud-action-btn stud-action-view"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleStudentClick(student);
                            }}
                            title="View Details"
                          >
                            <svg
                              width="15"
                              height="15"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                            >
                              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                              <circle cx="12" cy="12" r="3"></circle>
                            </svg>
                          </button>
                          <button
                            className={`stud-action-btn ${student.status === "Active" ? "stud-action-deactivate" : "stud-action-activate"}`}
                            onClick={(e) => handleToggleStatus(e, student.id)}
                            title={
                              student.status === "Active"
                                ? "Deactivate"
                                : "Activate"
                            }
                          >
                            <svg
                              width="15"
                              height="15"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                            >
                              <circle cx="12" cy="12" r="10"></circle>
                              <line x1="15" y1="9" x2="9" y2="15"></line>
                              <line x1="9" y1="9" x2="15" y2="15"></line>
                            </svg>
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {filteredStudents.length === 0 && (
              <div className="stud-empty-state">
                <svg
                  width="56"
                  height="56"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                </svg>
                <h3>No students found</h3>
                <p>Try adjusting your filters or search query</p>
              </div>
            )}
          </div>
        )}

        {viewMode === "grid" && (
          <div className="stud-grid">
            {filteredStudents.map((student) => {
              const progress =
                student.coursesEnrolled > 0
                  ? Math.round(
                      (student.coursesCompleted / student.coursesEnrolled) *
                        100,
                    )
                  : 0;
              return (
                <div
                  key={student.id}
                  className="stud-card"
                  onClick={() => handleStudentClick(student)}
                >
                  <div className="stud-card-top">
                    <span className="stud-id-badge">{student.id}</span>
                    <span
                      className={`stud-status-indicator stud-status-indicator-${student.status.toLowerCase()}`}
                    ></span>
                  </div>
                  <div className="stud-card-avatar">{student.avatar}</div>
                  <h3 className="stud-card-name">{student.name}</h3>
                  <p className="stud-card-email">{student.email}</p>
                  <span
                    className={`stud-status-badge stud-status-${student.status.toLowerCase()}`}
                  >
                    {student.status}
                  </span>
                  <div className="stud-card-progress">
                    <div className="stud-progress-bar">
                      <div
                        className="stud-progress-fill"
                        style={{ width: `${progress}%` }}
                      ></div>
                    </div>
                    <span className="stud-progress-pct">
                      {progress}% complete
                    </span>
                  </div>
                  <div className="stud-card-stats">
                    <div className="stud-card-stat">
                      <span className="stud-card-stat-lbl">Enrolled</span>
                      <span className="stud-card-stat-val">
                        {student.coursesEnrolled}
                      </span>
                    </div>
                    <div className="stud-card-stat">
                      <span className="stud-card-stat-lbl">Completed</span>
                      <span className="stud-card-stat-val">
                        {student.coursesCompleted}
                      </span>
                    </div>
                  </div>
                  <p className="stud-card-joined">
                    Joined {student.joinedDate}
                  </p>
                </div>
              );
            })}
            {filteredStudents.length === 0 && (
              <div className="stud-empty-state">
                <svg
                  width="56"
                  height="56"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                </svg>
                <h3>No students found</h3>
                <p>Try adjusting your filters or search query</p>
              </div>
            )}
          </div>
        )}

        {selectedStudent && (
          <div className="stud-modal-overlay" onClick={closeModal}>
            <div
              className="stud-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="stud-modal-header">
                <div className="stud-modal-user-header">
                  <div className="stud-modal-avatar">
                    {selectedStudent.avatar}
                  </div>
                  <div>
                    <div className="stud-modal-id">
                      Student ID: #{selectedStudent.id}
                    </div>
                    <h3>{selectedStudent.name}</h3>
                    <p>{selectedStudent.email}</p>
                  </div>
                </div>
                <button className="stud-close-btn" onClick={closeModal}>
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
              <div className="stud-modal-body">
                <div className="stud-badges-row">
                  <span className="stud-role-badge">Student</span>
                  <span
                    className={`stud-status-badge stud-status-${selectedStudent.status.toLowerCase()}`}
                  >
                    {selectedStudent.status}
                  </span>
                </div>
                <div className="stud-details-grid">
                  <div className="stud-detail-item">
                    <span className="stud-detail-lbl">Email</span>
                    <span className="stud-detail-val">
                      {selectedStudent.email}
                    </span>
                  </div>
                  <div className="stud-detail-item">
                    <span className="stud-detail-lbl">Phone</span>
                    <span className="stud-detail-val">
                      {selectedStudent.phone}
                    </span>
                  </div>
                  <div className="stud-detail-item">
                    <span className="stud-detail-lbl">Location</span>
                    <span className="stud-detail-val">
                      {selectedStudent.location}
                    </span>
                  </div>
                  <div className="stud-detail-item">
                    <span className="stud-detail-lbl">Joined Date</span>
                    <span className="stud-detail-val">
                      {selectedStudent.joinedDate}
                    </span>
                  </div>
                  <div className="stud-detail-item">
                    <span className="stud-detail-lbl">Courses Enrolled</span>
                    <span className="stud-detail-val">
                      {selectedStudent.coursesEnrolled}
                    </span>
                  </div>
                  <div className="stud-detail-item">
                    <span className="stud-detail-lbl">Courses Completed</span>
                    <span className="stud-detail-val">
                      {selectedStudent.coursesCompleted}
                    </span>
                  </div>
                </div>
              </div>
              <div className="stud-modal-footer">
                <button className="stud-modal-btn stud-modal-secondary">
                  Send Message
                </button>
                <button className="stud-modal-btn stud-modal-secondary">
                  View Activity
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default StudentsManagement;
